module.exports = __webpack_public_path__ + "img/307413a4-d77e-4111-8ba5-e3b7d1e7c160.4070295.svg";